// routes
import HomeRoute from "App/screens/Home/HomeRoute";
import PolicyRoute from "./screens/Policy/PolicyRoute";

const routes = [
    HomeRoute,
    PolicyRoute
]

export default routes